import api from "./api";

export async function startCheckout(lookup_key) {
  const { data } = await api.post("/payments/checkout", {
    lookup_key,
    origin_url: window.location.origin,
  });
  window.location.href = data.checkout_url;
}

export async function openBillingPortal() {
  const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
  window.location.href = data.url;
}
